<svg width="7" height="11" viewBox="0 0 7 11" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 1L5.734 5.734L1.22 10.248" stroke="black"/>
</svg>
